import { localizedWorkspaces } from "../../intl/shared-resources/workspace.js";
import { ChipVariant, ChipType } from "../../components/chip/types.js";
import { Workspace } from "../../contract/pam.js";
const getWorkspaceChipsMapping = (chipType) => ({
  [Workspace.Global]: {
    label: localizedWorkspaces[Workspace.Global],
    chipType: ChipType.TagMark,
    chipVariant: ChipVariant.DropdownDefault
  },
  [Workspace.Security]: {
    label: localizedWorkspaces[Workspace.Security],
    chipType,
    chipVariant: ChipVariant.Purple
  },
  [Workspace.Payment]: {
    label: localizedWorkspaces[Workspace.Payment],
    chipType,
    chipVariant: ChipVariant.LightBlue
  },
  [Workspace.Kyc]: {
    label: localizedWorkspaces[Workspace.Kyc],
    chipType,
    chipVariant: ChipVariant.Turquoise
  },
  [Workspace.CustomerSupport]: {
    label: localizedWorkspaces[Workspace.CustomerSupport],
    chipType,
    chipVariant: ChipVariant.LightGreen
  },
  [Workspace.Fraud]: {
    label: localizedWorkspaces[Workspace.Fraud],
    chipType,
    chipVariant: ChipVariant.Orange
  },
  GlobalRead: {
    label: localizedWorkspaces.GlobalRead,
    chipType: ChipType.TagMark,
    chipVariant: ChipVariant.DropdownDefault
  }
});
export {
  getWorkspaceChipsMapping
};
//# sourceMappingURL=workspaceChipsConfig.js.map
